import * as Moment from 'dayjs';

const filterRender = (val) => {
  if (!val && val !== 0) {
    return '--';
  }

  return val;
};

export function shippedOrdersTable () {
  const frontCols = [
    {
      title: '商品编码（sku）',
      field: 'skuCode',
      tooltip: true,
      minWidth: '130px',
      formatter: ({ row }) => {
        return row.outSkuCode ? filterRender(row.outSkuCode) : filterRender(row.skuCode);
      },
    },
    {
      title: '商品名称',
      field: 'goodsName',
      tooltip: true,
      minWidth: '130px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      title: '规格',
      field: 'specification',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.specification);
      },
    },
    {
      title: '型号',
      field: 'model',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.model);
      },
    },
    {
      title: '所属品牌',
      field: 'brandName',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      title: '生产商',
      field: 'manufacturer',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.manufacturer);
      },
    },
    {
      title: '厂家编码',
      field: 'factoryCode',
      tooltip: true,
      minWidth: '120px',
      formatter: ({ row }) => {
        return filterRender(row.factoryCode);
      },
    },
    {
      title: '发货数量',
      field: 'quantity',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return filterRender(row.quantity) + (row.unitName ? filterRender(row.unitName) : '');
      },
    },
    {
      title: '生产日期',
      dataIndex: 'productionDate',
      width: 160,
      ellipsis: true,
      formatter: ({ row }) => {
        return row.productionDate ? Moment(row.productionDate).format('YYYY-MM-DD') : '--';
      },
    },
    {
      title: '失效日期',
      dataIndex: 'expiryDate',
      width: 160,
      ellipsis: true,
      formatter: ({ row }) => {
        return row.expiryDate ? Moment(row.expiryDate).format('YYYY-MM-DD') : '--';
      },
    },
    {
      title: '生产批次号',
      field: 'batchNo',
      tooltip: true,
      minWidth: '120px',
      formatter: ({ row }) => {
        return filterRender(row.batchNo);
      },
    },
    {
      title: '生产序列号',
      field: 'serialNo',
      tooltip: true,
      minWidth: '120px',
      formatter: ({ row }) => {
        return filterRender(row.serialNo);
      },
    },
  ];
  const endCols = [
    {
      title: '是否医疗件',
      field: 'medicalFlag',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row['medicalFlag'] ? '是' : '否';
      },
    },
    {
      title: '产品注册证/备案凭证',
      field: 'certificateNumber',
      tooltip: true,
      minWidth: '160px',
      formatter: ({ row }) => {
        return filterRender(row.certificateNumber);
      },
    },
  ];

  let columns = [];
  columns = [
    ...frontCols,
    ...endCols,
  ];
  return columns;
}
